// API client — Pilotage Mandats (Lot M6).
const BASE = process.env.REACT_APP_BACKEND_URL || "";

async function req(path, opts = {}) {
  const { method = "GET", body } = opts;
  const res = await fetch(`${BASE}${path}`, {
    method,
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: body ? JSON.stringify(body) : undefined,
  });
  const text = await res.text();
  const data = text ? JSON.parse(text) : null;
  if (!res.ok) {
    const err = new Error(data?.detail?.code || data?.detail || `HTTP ${res.status}`);
    err.status = res.status;
    err.detail = data?.detail;
    throw err;
  }
  return data;
}

export const pilotageMandates = {
  actions: ({ commercial_id, severity, reason, limit } = {}) => {
    const qs = new URLSearchParams();
    if (commercial_id) qs.set("commercial_id", commercial_id);
    if (severity)      qs.set("severity",      severity);
    if (reason)        qs.set("reason",        reason);
    if (limit)         qs.set("limit",         String(limit));
    const s = qs.toString();
    return req(`/api/pilotage/mandates/actions${s ? `?${s}` : ""}`);
  },
  mandateSignals: (mandateId) => req(`/api/mandates/${mandateId}/signals`),
};

export default pilotageMandates;
